import React, { Component } from 'react';
// import ReactTable from "react-table"
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
// import { DialogComponent } from '@syncfusion/ej2-react-popups';
// import { MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import DataTable from 'react-data-table-component';
import { tokenVerification } from './Utils';

class Nurse extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false,

            });
        };
        this.DeletedialogClose = () => {
            this.setState({ hideTextAreaPopup: false });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteStaffDetail(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchStaffDetails()
                this.setState({ disabled: false })
            }
        }];



        this.state = {
            healthSystemId: '',
            hospitalId: '',
            serviceLineId: '',
            languages: [],
            nativeValue: [],
            dataFields: { text: 'nativeName' + '/' + 'language', value: 'language' },
            value: [],
            editedBooleanValue: false,
            procedureData: '',
            data: [{
                id: '',
                userName: '',
                userPhoneNumber: '',
                userEmailId: ''
            }],
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            contentEditable: "false",
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            successResp: false,
            pageNum: null,
            userRoleId: '',
            paginationValue: 10,
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.procedureVar = [];

    }

    addRow = (data) => {
        var UserController = this;
        UserController.state.paginationValue = UserController.state.paginationValue+5;
        if (UserController.state.pageNum != 0) {
            UserController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            name: '',
            phoneNumber: '',
            emailId: '',
        });
        this.setState({
            data: this.state.data,
            disabled: true,
        })
    }
    fetchStaffDetails = () => {
        var fetchController = this;
        var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
        var healthSystemId;
        var hospitalId;
        var serviceLineId;

        if (userRole == 'HEALTHSYSTEM_ADMIN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            hospitalId = document.getElementById('hospitalDropDown').value;
            serviceLineId = document.getElementById('serviceLine').value;
        } else if (userRole == 'HOSPITAL_ADMIN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            hospitalId = JSON.parse(localStorage.getItem("user_details"))["hospitalId"];
            serviceLineId = document.getElementById('serviceLine').value;
        } else if (userRole == 'SERVICELINE_ADMIN' || userRole == 'PROCEDURE_ADMIN' || userRole == 'PHYSICIAN' || userRole == 'NURSE') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            hospitalId = JSON.parse(localStorage.getItem("user_details"))["hospitalId"];
            serviceLineId = JSON.parse(localStorage.getItem("user_details"))["serviceLineId"]
        } else {
            healthSystemId = document.getElementById('healthSystem').value;
            hospitalId = document.getElementById('hospitalDropDown').value;
            serviceLineId = document.getElementById('serviceLine').value
        }
        $.ajax({
            url: "/my-jeeva-api/provider",
            
            method: 'GET',
            data: {
                role: 'NURSE',
                healthSystemId: healthSystemId,
                hospitalId: hospitalId,
                serviceLineId: serviceLineId
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    fetchController.setState({
                        data: res.result,
                        disabled: false
                    })
                }
                else {
                    fetchController.NotifyFailToLoad();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });

    }
    editLanguages = () => {

        this.setState({ editedBooleanValue: true })
    }
    notifySelectHealthSystem() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Please Select Health System</b>, {
            position: "top-center"
        });
    }
    notifySelectHospital() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Please Select Hospital</b>, {
            position: "top-center"
        });
    }
    notifySelectServiceLine() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Please Select Service Line</b>, {
            position: "top-center"
        });
    }
    saveUserApi(props, e) {
        var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
        var healthSystemId;
        var hospitalId;
        var serviceLineId;
        if (userRole == 'HEALTHSYSTEM_ADMIN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            hospitalId = document.getElementById("hospitalDropDown").value;
            serviceLineId = document.getElementById('serviceLine').value
        }
        else if (userRole == 'HOSPITAL_ADMIN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            hospitalId = JSON.parse(localStorage.getItem("user_details"))["hospitalId"];
            serviceLineId = document.getElementById('serviceLine').value;

        }

        else if (userRole == 'SERVICELINE_ADMIN' || userRole == 'PROCEDURE_ADMIN' || userRole == 'PHYSICIAN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            hospitalId = JSON.parse(localStorage.getItem("user_details"))["hospitalId"];
            serviceLineId = JSON.parse(localStorage.getItem("user_details"))["serviceLineId"]
        } else {
            healthSystemId = document.getElementById('healthSystem').value;
            hospitalId = document.getElementById("hospitalDropDown").value;
            serviceLineId = document.getElementById('serviceLine').value
        }
        var thisController = this;
        if (healthSystemId == 'Select Health System') {
            thisController.notifySelectHealthSystem();
        } else if (hospitalId == 'Select Hospital') {
            thisController.notifySelectHospital();
        } else if (serviceLineId == 'Select Service Line') {
            thisController.notifySelectServiceLine();
        } else {
            props.name = document.getElementById("name" + props.index).innerText.trim();
            props.phoneNumber = document.getElementById("phoneNumber" + props.index).innerText.trim();
            props.emailId = document.getElementById("emailId" + props.index).innerText.trim();
            props.designation = document.getElementById("designation" + props.index).innerText.trim();
            props.comments = document.getElementById("comments" + props.index).innerText.trim();

            this.state.editedId = "-1";
            this.setState(this.state);

            var addUserController = this
            $.ajax({
                url: "/my-jeeva-api/provider-admin",
                
                method: 'POST',
                data: {
                    userName: props.name,
                    userPhoneNumber: props.phoneNumber,
                    userEmail: props.emailId,
                    role: 'NURSE',
                    healthSystemId: healthSystemId,
                    serviceLineId: serviceLineId,
                    hospitalId: hospitalId,
                    designation: props.designation,
                    comments: props.comments

                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },

                success: function (res) {
                    if (res.success === true) {
                        addUserController.notifyAdded();
                        addUserController.fetchStaffDetails();
                        addUserController.setState({ disabled: false })
                    } else {

                        addUserController.notifyFailedResponse(res.result);

                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            })
        }

    }

    updateUserApi(props, e) {
        var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
        var healthSystemId;
        var hospitalId;
        var serviceLineId;

        if (userRole == 'HEALTHSYSTEM_ADMIN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            hospitalId = document.getElementById("hospitalDropDown").value;
            serviceLineId = document.getElementById('serviceLine').value;
        }
        else if (userRole == 'HOSPITAL_ADMIN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            hospitalId = JSON.parse(localStorage.getItem("user_details"))["hospitalId"];
            serviceLineId = document.getElementById('serviceLine').value

        }
        else if (userRole == 'SERVICELINE_ADMIN' || userRole == 'PROCEDURE_ADMIN' || userRole == 'PHYSICIAN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            hospitalId = JSON.parse(localStorage.getItem("user_details"))["hospitalId"];
            serviceLineId = JSON.parse(localStorage.getItem("user_details"))["serviceLineId"]
        } else {
            healthSystemId = document.getElementById('healthSystem').value;
            hospitalId = document.getElementById("hospitalDropDown").value;
            serviceLineId = document.getElementById('serviceLine').value;
        }
        var thisController = this;
        if (healthSystemId == 'Select Health System') {
            thisController.notifySelectHealthSystem();
        } else if (hospitalId == 'Select Hospital') {
            thisController.notifySelectHospital();
        } else if (serviceLineId == 'Select Service Line') {
            thisController.notifySelectServiceLine();
        } else {
            props.name = document.getElementById("name" + props.index).innerText.trim();
            props.phoneNumber = document.getElementById("phoneNumber" + props.index).innerText.trim();
            props.emailId = document.getElementById("emailId" + props.index).innerText.trim();

            props.designation = document.getElementById("designation" + props.index).innerText.trim();
            props.comments = document.getElementById("comments" + props.index).innerText.trim();

            var updatedDataController = this
            var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
            var contactNumberPattern = new RegExp(/^(?=.*\d).+$/);

            if (props.name == "" || props.phoneNumber == "" || props.emailId == "" || props.designation == "" || props.comments == null) {
                updatedDataController.notifyMsgFieldEmpty();
            }
            else if (!pattern.test(props.emailId)) {
                updatedDataController.notifyImproperEmailId();
            }
            else if (!contactNumberPattern.test(props.phoneNumber)) {

                updatedDataController.notifyImproperContactNumber();
            }
            var saveData = {
                id: props.id,
                procedureId: document.getElementById("procedureId" + props.index).value,
                // serviceLineId: updatedDataController.props.location.state.serviceLineId,
                // hospitalId: updatedDataController.props.location.state.hospitalId,
                // healthSystemId: updatedDataController.props.location.state.healthSystemId,
                userEmailId: props.emailId,
                userName: props.name,
                userPhoneNumber: props.phoneNumber,
                userRole: 'NURSE',
                healthSystemId: healthSystemId,
                hospitalId: hospitalId,
                serviceLineId: serviceLineId,
                procedureId: document.getElementById("procedureId" + props.index).value,
                designation: document.getElementById("designation" + props.index).innerText.trim(),
                comments: document.getElementById("comments" + props.index).innerText.trim()

            }
            $.ajax({
                url: "/my-jeeva-api/provider",
                
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                data: JSON.stringify(saveData),
                success: function (res) {
                    if (res.success === true) {
                        if (res.result.success == false) {
                            thisController.notifyResponse(res.result.result);
                            thisController.state.disabled = false;
                        } else {
                            updatedDataController.state.editedId = "-1";
                            updatedDataController.notifyUpdate();
                            updatedDataController.setState({ editedBooleanValue: false })
                            updatedDataController.fetchStaffDetails();
                        }
                    } else {

                        updatedDataController.notifyFailedToUpdate(res.result);
                        updatedDataController.state.disabled = false;
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }


            })
        }

    }
    refreshLanguagesOfTheProject = () => {
        this.fetchProcedureDataApi();
        this.setState({ editedBooleanValue: false })
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    notifyImproperEmailId() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid email id</b>, {
            position: "top-center"
        });

    }
    notifyImproperContactNumber() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid contact number</b>, {
            position: "top-center"
        });
    }

    deleteStaffDetail = (props) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (props.id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(props.id, 1);
        } else {
            var deleteData = {
                id: props.id,
                emailId: props.userEmailId,
                userRole: 'NURSE'
            }
            $.ajax({
                url: "/my-jeeva-api/delete-user",
                
                method: 'POST',
                data: JSON.stringify(deleteData),
                headers: { 
                    "Authorization": "Bearer " + localStorage.getItem("access_token") ,
                    'Content-Type': "application/json"
                },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteConstructorVariables.notifyDelete();
                        deleteRowViewController.splice(props.id, 1);
                    } else {
                        // deleteRowViewController.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            });
        }

        if (this.state.deleteRow) {
            this.state.data.splice(props.id, 1);
        }
        deleteConstructorVariables.fetchStaffDetails();


    }
    makeCelledit(props, e) {
        this.markAsBeingEdited(props.id);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }
    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Nurse details updated successfully</b>, {
            position: "top-center",
        });
    }
    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }

    fetchHospitalDetails() {
        var fetchController = this;
        var responseData = [];
        var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
        var healthSystemId;
        if (userRole == 'HEALTHSYSTEM_ADMIN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            fetchController.state.hospitalId = document.getElementById("hospitalDropDown").value;
        } else if (userRole == 'HOSPITAL_ADMIN' || userRole == 'SERVICELINE_ADMIN'
            || userRole == 'PHYSICIAN' || userRole == 'PROCEDURE_ADMIN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            fetchController.state.hospitalId = JSON.parse(localStorage.getItem("user_details"))["hospitalId"];
        } else {
            healthSystemId = document.getElementById('healthSystem').value;
            fetchController.state.hospitalId = document.getElementById("hospitalDropDown").value;
        }

        $.ajax(
            {
                url: "/my-jeeva-api/hospital",
                
                method: 'GET',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                }, data: {
                    healthSystemId: healthSystemId
                },
                success: function (res) {
                    if (res.success === true) {
                        responseData = res.result;
                        var numberOfuserRoles = responseData.length;
                        var ele3 = document.getElementById("hospitalDropDown");
                        if (ele3 != "") {
                            if (ele3 != null) {
                                if (ele3.value != "Select Hospital") {
                                    ele3.innerHTML = "";
                                }
                                ele3.innerHTML = ele3.innerHTML + '<option value="Select Hospital" hidden> Select Hospital</option>';

                                for (var i = 0; i < numberOfuserRoles; i++) {
                                    ele3.innerHTML = ele3.innerHTML + '<option value="' + responseData[i]['id'] +
                                        '">' + responseData[i]['name'] + '</option>';


                                }
                            }
                        }
                        fetchController.state.hospitalId = document.getElementById('hospitalDropDown').value
                    }

                    else {
                        fetchController.notifyFailedResponse(res.result);
                    }
                }, error: function (xhr, status, error) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            }
        )

    }
    componentDidMount() {
        var thisController = this;

        setTimeout(() => {
            thisController.fetchHealthSystemDetails();
            thisController.fetchHospitalDetails();
            thisController.fetchServiceLineDetails();
            thisController.fetchProcedureDataApi();
            thisController.fetchStaffDetails();
        }, 300);


    }
    notifyEmptyFieldForAdd() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    fetchProcedureDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var fetchDataContoller = this;
        var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
        var healthSystemId;
        var hospitalId;
        var serviceLineId;

        if (userRole == 'HEALTHSYSTEM_ADMIN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            hospitalId = document.getElementById("hospitalDropDown").value;
            serviceLineId = document.getElementById('serviceLine').value
        }
        else if (userRole == 'HOSPITAL_ADMIN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            hospitalId = JSON.parse(localStorage.getItem("user_details"))["hospitalId"];
            serviceLineId = document.getElementById('serviceLine').value;

        }
        else if (userRole == 'SERVICELINE_ADMIN' || userRole == 'PROCEDURE_ADMIN'
            || userRole == 'PHYSICIAN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            hospitalId = JSON.parse(localStorage.getItem("user_details"))["hospitalId"];
            serviceLineId = JSON.parse(localStorage.getItem("user_details"))["serviceLineId"]
        } else {
            healthSystemId = document.getElementById('healthSystem').value;
            hospitalId = document.getElementById("hospitalDropDown").value;
            serviceLineId = document.getElementById('serviceLine').value;
        }

        $.ajax({
            url: "/my-jeeva-api/procedure",
            
            method: 'GET',
            data: {
                serviceLineId: serviceLineId,
                healthSystemId: healthSystemId,
                hospitalId: hospitalId

            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    var socialPlatformPropertys = res.result;
                    var numberOfsocialPlatformPropertys = socialPlatformPropertys.length;
                    fetchDataContoller.procedureVar = [];


                    for (var i = 0; i < numberOfsocialPlatformPropertys; i++) {

                        fetchDataContoller.procedureVar[i] = (socialPlatformPropertys[i]);

                    }


                }


            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });

    }


    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchStaffDetails()
        this.setState({ disabled: false })
    }

    notifyAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Nurse details added successfully</b>, {
            position: "top-center",
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Nurse detail deleted successfully</b>, {
            position: "top-center",
        });
    }




    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }



    notifyFailedDelete(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });


    }

    notifyDeleteAllSuccess() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
                content="" />&nbsp;&nbsp;All Mlts have been deleted Successfully</b>, {
            position: "top-center",
        });

    }
    notifyNodata(response) {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
                content="" />&nbsp;&nbsp;Please Select the Nurse role</b>, {
            position: "top-center",
        });


    }




    rolehandleChange = () => {
        let valueOfuserRoleId = document.getElementById('userRole').value;
        this.state.userRoleId = valueOfuserRoleId;

        this.fetchStaffDetails();
    }
    fetchHealthSystemDetails() {
        var fetchController = this;
        var responseData = [];
        $.ajax(
            {
                url: "/my-jeeva-api/health-system",
                
                method: 'GET',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {
                    if (res.success === true) {
                        responseData = res.result;
                        var numberOfuserRoles = responseData.length;
                        var ele3 = document.getElementById("healthSystem");
                        if (ele3 != "") {
                            if (ele3 != null) {
                                if (ele3.value != "Select Health System") {
                                    ele3.innerHTML = "";
                                }
                                ele3.innerHTML = ele3.innerHTML + '<option value="Select Health System" hidden> Select Health System</option>';

                                for (var i = 0; i < numberOfuserRoles; i++) {
                                    ele3.innerHTML = ele3.innerHTML + '<option value="' + responseData[i]['id'] +
                                        '">' + responseData[i]['name'] + '</option>';


                                }
                            }
                        }
                        fetchController.state.healthSystemId = document.getElementById('healthSystem').value
                    }

                    else {
                        fetchController.notifyFailedResponse(res.result);
                    }
                }, error: function (xhr, status, error) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            }
        )

    }
    fetchServiceLineDetails() {
        var fetchController = this;
        var responseData = [];
        var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
        var healthSystemId;
        var hospitalId;
        if (userRole == 'HEALTHSYSTEM_ADMIN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"]
            hospitalId = document.getElementById("hospitalDropDown").value;
        }
        else if (userRole == 'HOSPITAL_ADMIN' || userRole == 'SERVICELINE_ADMIN'
            || userRole == 'PHYSICIAN' || userRole == 'PROCEDURE_ADMIN') {
            healthSystemId = JSON.parse(localStorage.getItem("user_details"))["healthSystemId"];
            hospitalId = JSON.parse(localStorage.getItem("user_details"))["hospitalId"];
        } else {
            healthSystemId = document.getElementById('healthSystem').value;
            hospitalId = document.getElementById("hospitalDropDown").value;
        }
        $.ajax(
            {
                url: "/my-jeeva-api/service-line",
                
                method: 'GET',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                }, data: {
                    healthSystemId: healthSystemId,
                    hospitalId: hospitalId
                },
                success: function (res) {
                    if (res.success === true) {
                        responseData = res.result;
                        var numberOfuserRoles = responseData.length;
                        var ele3 = document.getElementById("serviceLine");
                        if (ele3 != "") {
                            if (ele3 != null) {
                                if (ele3.value != "Select Service Line") {
                                    ele3.innerHTML = "";
                                }
                                ele3.innerHTML = ele3.innerHTML + '<option value="Select Service Line" hidden> Select Service Line</option>';


                                for (var i = 0; i < numberOfuserRoles; i++) {
                                    ele3.innerHTML = ele3.innerHTML + '<option value="' + responseData[i]['id'] +
                                        '">' + responseData[i]['name'] + '</option>';


                                }
                            }
                        }
                    }

                    else {
                        fetchController.notifyFailedResponse(res.result);
                    }
                }, error: function (xhr, status, error) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            }
        )

    }
    serviceLineHandleChange = () => {
        this.state.serviceLineId = document.getElementById('serviceLine').value;
        this.setState(this.state);
        this.fetchProcedureDataApi();
        this.fetchStaffDetails();
    }
    healthSystemHandleChange = () => {
        this.state.healthSystemId = document.getElementById('healthSystem').value;
        this.setState(this.state);
        this.fetchHospitalDetails();
        this.fetchServiceLineDetails();
        this.fetchProcedureDataApi();
        this.fetchStaffDetails();
    }
    hospitalHandleChange = () => {
        this.state.hospitalId = document.getElementById('hospitalDropDown').value;
        this.setState(this.state);
        this.fetchServiceLineDetails();
        this.fetchProcedureDataApi();

        this.fetchStaffDetails();
    }

    optionHandleChange = (props, e) => {
        props.userName = document.getElementById("name" + props.index).innerText;
        props.userPhoneNumber = document.getElementById("phoneNumber" + props.index).innerText;
        props.userEmailId = document.getElementById("emailId" + props.index).innerText;
        props.procedureId = e.target.value;
        // for (var i = 0; i < this.state.selectedValue.length; i++) {
        //     if (props.procedureId == this.state.selectedValue[i]) {
        //     }
        // }

        this.setState(this.state);
    }

    render() {
        const { data } = this.state;
        const columns = [
            {
                name:<b>Name</b>,
                selector: (props) => (
                    <div name="name">
                        <div className="textarea"
                            style={{
                                background: 'white', height: "2.7em", resize: 'none',
                                paddingLeft: '2px', paddingTop: '6px', width: '98%',
                                border: (props.id == "" || props.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                borderRadius: (props.id == "") ? '2px' : 'none'
                            }}
                            id={"name" + props.index}
                            contentEditable={!((props.id == "") ? false :
                                props.id != this.state.editedId) ? "plaintext-only" : false}
                        >{props.userName}
                        </div>
                    </div>)
            },
            {
                name: <b>Contact Number</b>,
                selector: (props) => (
                    <div name="phoneNumber">
                        <div className="textarea"
                            style={{
                                background: 'white', height: "2.7em", resize: 'none', paddingLeft: '2px', paddingTop: '6px',
                                width: '98%',
                                border: (props.id == "" || props.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                borderRadius: (props.id == "") ? '2px' : 'none'
                            }}
                            id={"phoneNumber" + props.index}
                            contentEditable={!((props.id == "") ? false :
                                props.id != this.state.editedId) ? "plaintext-only" : false}
                        >{props.userPhoneNumber}
                        </div>
                    </div>)
            }, {
                name: <b>Email ID</b>,
                selector: (props) => (
                    <div name="emailId">
                        <div className="textarea"
                            style={{
                                background: 'white', height: "2.7em", resize: 'none', paddingLeft: '2px', paddingTop: '6px',
                                width: '98%',
                                border: (props.id == "" || props.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                borderRadius: (props.id == "") ? '2px' : 'none'
                            }}
                            id={"emailId" + props.index}
                            contentEditable={!((props.id == "") ? false :
                                props.id != this.state.editedId) ? "plaintext-only" : false}
                        >{props.userEmailId}
                        </div>
                    </div>)
            }, {
                name:<b>Designation</b>,
                selector: (props) => (
                    <div name="designation">
                        <div className="textarea"
                            style={{
                                background: 'white', height: "2.7em", resize: 'none', paddingLeft: '2px', paddingTop: '6px',
                                width: '98%',
                                border: (props.id == "" || props.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                borderRadius: (props.id == "") ? '2px' : 'none'
                            }}
                            id={"designation" + props.index}
                            contentEditable={!((props.id == "") ? false :
                                props.id != this.state.editedId) ? "plaintext-only" : false}
                        >{props.designation}
                        </div>
                    </div>)
            }, {
                name:<b>Treatment</b>,
                selector: (props) => (
                    <div className="container-fluid" style={{ textAlign: "right" }}>
                        <div className="container-fluid" style={{ textAlign: "right" }}>
                            <select className="input-group form-control select2 "
                                onChange={(e) => this.optionHandleChange(props, e)}
                                value={props.procedureId} id={"procedureId" + props.index}
                                style={{
                                    marginLeft: '-2vw',
                                    background: 'white', border: 'none',
                                    border: (props.id == undefined || props.id == this.state.editedId) ?
                                        '1px solid #D2D4DC' : 'none', borderRadius: (props.id == undefined) ? '2px' : 'none'
                                }}
                                disabled={(props.id == "") ? false : props.id != this.state.editedId}
                            >
                                {this.procedureVar.map(socialPlatformProperty => (
                                    <option key={socialPlatformProperty} value={socialPlatformProperty['id']} >
                                        {socialPlatformProperty['name']}
                                    </option>

                                ))}
                                <option hidden value='Select Procedure'>Select Procedure</option>

                            </select>
                        </div>

                    </div>)
            }, {
                name: <b>Comments</b>,
                selector: (props) => (
                    <div name="comments">
                        <div className="textarea"
                            style={{
                                background: 'white', height: "2.7em", resize: 'none', paddingLeft: '2px', paddingTop: '6px',
                                width: '98%',
                                border: (props.id == "" || props.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                borderRadius: (props.id == "") ? '2px' : 'none'
                            }}
                            id={"comments" + props.index}
                            contentEditable={!((props.id == "") ? false :
                                props.id != this.state.editedId) ? "plaintext-only" : false}
                        >{props.comments}
                        </div>
                    </div>)
            },

            {
                name: <b>Action</b>,
                width: 200,
                selector: (props) => (
                    <div id="action">
                        <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px' }} >
                            <img className="img-responsive"
                                title={(props.id == "") ||
                                    (props.id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                src={(props.id == "") ? this.saveImageSrc : ((props.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.id == "") ? this.saveUserApi(props, e) : (props.id == this.state.editedId) ?
                                        this.updateUserApi(props, e) : this.makeCelledit(props, e);
                                }} />
                        </button>


                        <button style={{
                            backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px'
                        }} title="Delete">
                            <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                onClick={() => (props.id) === '' ?
                                    this.fetchStaffDetails() :
                                    this.setState({
                                        hideDeletePopup: true, deletePropIndex: props.index, propsId: props
                                    })} /></button>
                    </div>), width: 100
            },
        ]
        return (
            <div style={{ marginRight: '1%' }} id='nurseTab'>
                <div style={{ background: "#F9F9FB" }} >
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | BackEnd Api </title>
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />


                    <div className="row" style={{ marginLeft: '14px' }}>
                        <div className='col-sm-1'>
                            <h6 className="nav-item" style={{ color: '#282a65', marginTop: '1vh' }}>
                                Nurse </h6>
                        </div>
                        <div className='col-sm-9' Align='right'>
                            <label style={{ display: (window.SCOPE_VALUE.CURRENT > window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) ? 'inline' : 'none' }}>
                                Health System</label>
                            <select
                                id="healthSystem" className="healthSystem"
                                onChange={this.healthSystemHandleChange} placeholder="Select Health System"
                                style={{
                                    display: (window.SCOPE_VALUE.CURRENT > window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) ? 'inline' : 'none',
                                    height: '30px', borderRadius: '4px',
                                    backgroundColor: '#F9F9FB', width: '13vw', marginLeft: '10px'
                                }}>
                                {/* <option hidden value='Select Health System'>Select Health System</option> */}

                            </select>
                            <label style={{
                                marginLeft: '3vh',
                                display: (window.SCOPE_VALUE.CURRENT > window.SCOPE_VALUE.HOSPITAL_ADMIN) ? 'inline' : 'none'
                            }}>Hospital</label>
                            <select
                                id="hospitalDropDown" className="hospitalDropDown"
                                onChange={this.hospitalHandleChange} placeholder="Select Hospital"
                                style={{
                                    display: (window.SCOPE_VALUE.CURRENT > window.SCOPE_VALUE.HOSPITAL_ADMIN) ? 'inline' : 'none',
                                    height: '30px', borderRadius: '4px',
                                    backgroundColor: '#F9F9FB', width: '13vw', marginLeft: '10px'
                                }}>
                                {/* <option hidden value='Select Hospital'>Select Hospital</option> */}

                            </select>

                            <label style={{
                                marginLeft: '3vh',
                                display: (window.SCOPE_VALUE.CURRENT > window.SCOPE_VALUE.SERVICELINE_ADMIN) ? 'inline' : 'none'

                            }}>Service Line</label>
                            <select
                                id="serviceLine" className="serviceLine"
                                onChange={this.serviceLineHandleChange} placeholder="Select Service Line"
                                style={{
                                    display: (window.SCOPE_VALUE.CURRENT > window.SCOPE_VALUE.SERVICELINE_ADMIN) ? 'inline' : 'none',
                                    height: '30px', borderRadius: '4px',
                                    backgroundColor: '#F9F9FB', width: '13vw', marginLeft: '10px'
                                }}>
                                {/* <option hidden value='Select Service Line'>Select Service Line</option> */}

                            </select>
                        </div>
                        <div className="col-sm-2 " style={{ marginTop: '-18px' }}>
                            <div className="d-flex flex-row-reverse pt-2">

                                <div className="p-2" style={{ marginBottom: '10px' }}>

                                    <button className="btn action-button"
                                        id="addMsg" title=" Add "
                                        onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow}>
                                        <img src="assets/images/add_white_24dp.png" />
                                    </button>
                                    <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                                        <img src="./assets/images/refresh_white_24dp.png"></img></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ marginLeft: '15px' }}>
                        <div className="col-lg-12 ">
                            <div className="card">
                                <DataTable
                                    data={data}
                                    columns={columns}
                                    defaultPageSize={10}
                                    pageSizeOptions={[5, 10, 15]}
                                    onPageChange={this.onPageChange}
                                    pagination={this.state.paginationValue}


                                />
                            </div>
                            <ToastContainer className="Toast-at-center" />

                            {/* <DialogComponent width='400px' animationSettings={this.settings}
                                header='Delete Confirmation' showCloseIcon={true} buttons={this.buttons}
                                ref={dialog => this.dialogInstance = dialog} target='#nurseTab'
                                visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                    content="" />&nbsp;&nbsp;&nbsp;&nbsp;Do you want to delete this Nurse Detail?<br />
                                Note: Press 'Yes' to delete or press 'No' to decline.
                            </DialogComponent> */}

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Nurse;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/Nurse.js